var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"8px"}},[_c('div',{staticClass:"bg-yellow h-inherit",style:('width:' + _vm.getWidth)})])}
var staticRenderFns = []

export { render, staticRenderFns }